export enum DateFilterMode {
  FixedRange = 1,
  RollingRange = 2,
}